import { isLocalDev } from 'utils/isLocalDev';

import Cookie from './Cookie';

const { REACT_APP_REDIRECT_URI: wisHmUrl } = process.env;

const domain = isLocalDev ? undefined : wisHmUrl;

class AppCookie extends Cookie {
  constructor() {
    super(domain as string);
  }
}

const appCookie = new AppCookie();

export default appCookie;
